module.exports = __webpack_public_path__ + "img/DEDEC4_B5B597_F9F9EA_C4C4AB-256px.d9ae6dc6.png";